export default __webpack_public_path__ + "static/media/rambouillet06.1bd453cc.jpg";